import { Page } from '@/components';
import { useParams } from 'react-router-dom';
import DepositorsSkyTable from './DepositorsSkyTable';
import HistoricTabs from './HistoricTabs';
import { Flex, useTableProps } from '@blockanalitica/ui';
import TextSeatchFilter from '@/components/TextSearchFilter/TextSearchFilter';

export default function StakeDespositorsPage() {
  const { address } = useParams();
  const { pagination, sorting, filters } = useTableProps({
    filtersDebounceTime: 250,
    pageSize: 10,
    initialSorting: '-balance',
    initialFilters: {
      textSearch: ''
    }
  });
  return (
    <Page title="Stakers">
      <HistoricTabs address={address} />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSeatchFilter filters={filters} placeholder="Search by wallet" />
      </Flex>
      <DepositorsSkyTable
        address={address}
        pagination={pagination}
        sorting={sorting}
        search={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
